/** A poster URL never changes the medium of its source ad. */
export function isVideoAdSource(value: unknown): boolean {
 if (!value || typeof value !== 'object') return false;
 const row=value as Record<string,unknown>;
 if ([row.mediaType,row.media_type].some(type=>typeof type==='string'&&type.toLowerCase()==='video')) return true;
 if ([row.videoUrl,row.video_url].some(url=>typeof url==='string'&&url.trim().length>0)) return true;
 if ([row.mediaUrl,row.media_url,row.imageUrl].some(url=>typeof url==='string'&&/\.(?:mp4|webm|mov|m4v)(?:[?#]|$)/i.test(url))) return true;
 return !!row.analysisRaw && row.analysisRaw!==value && isVideoAdSource(row.analysisRaw);
}

export function isVerifiedStillAdSource(value: unknown): boolean {
 if (!value || typeof value!=='object' || isVideoAdSource(value)) return false;
 const row=value as Record<string,unknown>;
 const raw=row.analysisRaw&&typeof row.analysisRaw==='object'?row.analysisRaw as Record<string,unknown>:{};
 return [row.mediaType,row.media_type,raw.mediaType,raw.media_type].some(type=>typeof type==='string'&&['image','carousel'].includes(type.toLowerCase()));
}

/** Downloads preserve the source medium; a missing video is never replaced by its poster. */
export function adSourceDownloadUrl(value: {mediaType?: string | null; imageUrl?: string | null; videoUrl?: string | null}): string | undefined {
 return (isVideoAdSource(value) ? value.videoUrl : value.imageUrl) || undefined;
}
